import { useState } from "react";
import { PageHeader } from "@/components/PageHeader";
import { TelegramBotCard } from "@/components/connections/TelegramBotCard";
import { WhatsappConnectionCard } from "@/components/connections/WhatsappConnectionCard";
import { TelegramConnectionCard } from "@/components/connections/TelegramConnectionCard";
import { cn } from "@/lib/utils";

type TabId = "conexoes" | "monitoramento";

const tabs: { id: TabId; label: string }[] = [
  { id: "conexoes", label: "Conexões" },
  { id: "monitoramento", label: "Monitoramento" },
];

export function SettingsIntegracaoPage(): JSX.Element {
  const [activeTab, setActiveTab] = useState<TabId>("conexoes");

  return (
    <div className="max-w-3xl mx-auto space-y-6">
      {/* Cabecalho */}
      <PageHeader
        title="Integrações"
        subtitle="Conecte sua conta do Telegram e WhatsApp ao LucraLink."
      />

      {/* Abas */}
      <div
        className="flex gap-1 border-b border-border pb-px"
        role="tablist"
        aria-label="Abas de integração"
      >
        {tabs.map((tab) => (
          <button
            key={tab.id}
            role="tab"
            aria-selected={activeTab === tab.id}
            aria-controls={`tabpanel-${tab.id}`}
            onClick={() => setActiveTab(tab.id)}
            className={cn(
              "relative px-4 py-2.5 text-sm font-medium transition-colors",
              "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background",
              activeTab === tab.id
                ? "text-foreground"
                : "text-muted-foreground hover:text-foreground",
            )}
          >
            {tab.label}
            {activeTab === tab.id && (
              <span
                className="absolute inset-x-0 bottom-0 h-0.5 bg-primary rounded-full"
                aria-hidden="true"
              />
            )}
          </button>
        ))}
      </div>

      {/* Painel: Conexoes */}
      {activeTab === "conexoes" && (
        <div
          id="tabpanel-conexoes"
          role="tabpanel"
          aria-labelledby="tab-conexoes"
          className="space-y-6"
        >
          <WhatsappConnectionCard />
          <TelegramConnectionCard />
          <TelegramBotCard />
        </div>
      )}

      {/* Painel: Monitoramento */}
      {activeTab === "monitoramento" && (
        <div
          id="tabpanel-monitoramento"
          role="tabpanel"
          aria-labelledby="tab-monitoramento"
          className="space-y-6"
        >
          <div className="rounded-xl border border-border bg-card p-10 text-center">
            <p className="text-sm text-muted-foreground">
              O monitoramento em tempo real das suas integrações estará
              disponível em breve.
            </p>
          </div>
        </div>
      )}
    </div>
  );
}
